<template>
	<div class="embed-event">
		<h3>{{ eventName }}</h3>
		<div class="embed-event-description" v-if="hasEventDescription">
			{{ eventDescription }}
		</div>
		<div class="embed-event-bottom">
			<div class="embed-event-date-pill">
				<div>{{ eventMonth }}</div>
				<b>{{ eventDay }}</b>
			</div>
			<div class="embed-event-details">
				<div>
					<i class="sk-icon-clock-solid"></i>
					{{ eventTime }}
				</div>
				<div>
					<i class="sk-icon-utensils-solid"></i>
					{{ eventRestaurantName }}
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
h3 {
	font-weight: 600;
	color: var(--sk-embed-font-primary);
	font-size: 16px;
}

.embed-event {
	background: var(--sk-embed-bg-secondary);
	border-radius: 5px;
	border: 1px solid var(--sk-embed-border);
	padding: 20px;
	display: flex;
	flex-direction: column;
}

.embed-event h3,
.embed-event-description {
	margin-bottom: 15px;
}

.embed-event-description {
	color: var(--sk-embed-font-secondary);
	font-size: 12px;
}

.embed-event-bottom {
	display: flex;
	align-items: center;
	margin-top: auto;
}

.embed-event-details > div {
	font-size: 11px;
	color: var(--sk-embed-font-secondary);
}

.embed-event-details > div:first-child {
	margin-bottom: 8px;
}

.embed-event-details i {
	font-size: 10px;
	margin-right: 8px;
	color: var(--sk-embed-font-secondary);
}

.embed-event-date-pill {
	height: 50px;
	width: 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: var(--sk-embed-bg-tertiary);
	border-radius: 5px;
	margin-right: 20px;
}

.embed-event-date-pill > div {
	color: var(--sk-embed-font-secondary);
	font-size: 10px;
}

.embed-event-date-pill b {
	color: var(--sk-embed-font-secondary);
	font-size: 14px;
}
</style>

<script>
import eventDetailsMixin from "@/mixins/event-details-mixin"

export default {
	name: "EmbedEventCard",
	mixins: [eventDetailsMixin],
	props: {
		event: Object
	},
	computed: {
		hasEventDescription() {
			return this.event && this.event.description.length > 0
		}
	}
}
</script>